module.exports = __webpack_public_path__ + "img/icon-panel-close.71200ad6.svg";